import { TranslationService } from '@/utils/services';

export const nextIntlErrorHandlers = {
    /**
     * Suppress all next-intl errors to prevent polluting Datadog logs
     * This prevents errors from polluting Datadog logs
     */
    onError: (error) => {
        if (process.env.NODE_ENV === 'development') {
            console.warn('[next-intl] Translation error:', error);
        }
        return;
    },

    /**
     * Return the translation key path as fallback when message is missing
     * Uses TranslationService for consistent key formatting
     */
    getMessageFallback: ({ namespace, key }: { namespace?: string; key: string }) => {
        return TranslationService.getTranslationKey(namespace, key);
    }
};
